import React from 'react'
import InvoiceAction from './invoice.action'

function InvoiceDetails() {
  return (
    <InvoiceAction/>
  )
}

export default InvoiceDetails